/* unplugin-vue-components disabled */import ReportForm from './cpns/ReportForm.vue';
export default defineComponent({
  name: 'SaleForm',
  components: {
    ReportForm: ReportForm
  },
  setup: function setup() {
    // onMounted(async () => {
    // });
    return {};
  }
});